export function isOfficeViewerSupportedByMimeOrExtension(input: string): boolean {
  const supportedExtensions = [
    '.doc',
    '.docx',
    '.docm',
    '.dot',
    '.dotx',
    '.dotm',
    '.xls',
    '.xlsx',
    '.xlsb',
    '.xlsm',
    '.xlt',
    '.xltx',
    '.xltm',
    '.ppt',
    '.pptx',
    '.pptm',
    '.pps',
    '.ppsx',
    '.ppsm',
    '.pot',
    '.potx',
    '.potm',
    '.pdf',
    '.vsd',
    '.vsdx',
  ];

  const mimeToExtensionMap: Record<string, string> = {
    msword: '.doc',
    'vnd.msword': '.doc',
    'vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
    'vnd.ms-word.document.macroEnabled.12': '.docm',
    'vnd.ms-excel': '.xls',
    'vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
    'vnd.ms-excel.sheet.binary.macroEnabled.12': '.xlsb',
    'vnd.ms-excel.sheet.macroEnabled.12': '.xlsm',
    'ms-powerpoint': '.ppt',
    'vnd.ms-powerpoint': '.ppt',
    'vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx',
    'vnd.ms-powerpoint.presentation.macroEnabled.12': '.pptm',
    'vnd.visio': '.vsd',
    'vnd.ms-visio.drawing.main+xml': '.vsdx',
    xlsx: '.xlsx',
    xls: '.xls',
    // Add more as needed
  };

  let ext: string;

  if (input.startsWith('.')) {
    // It's already a file extension
    ext = input.toLowerCase();
  } else {
    // It's a MIME subtype
    ext = mimeToExtensionMap[input] || '';
  }

  return supportedExtensions.includes(ext);
}
